import { closePopup } from "../popup/popup";

declare var pm: PmInterface;

export default function setupGuidelines($: JQueryStatic) {
	const { findHtmlEl, findInputEl } = pm.utils.dom;

	findInputEl("#guidelines-agreement")?.addEventListener("change", function () {
		const guidelinesButton = findHtmlEl(".guidelines-button");
		if (!guidelinesButton) return;

		if (this.checked) {
			guidelinesButton.classList.remove("disabled");
			guidelinesButton.classList.remove("wpbf-button-secondary");
			guidelinesButton.classList.add("wpbf-button-primary");
		} else {
			guidelinesButton.classList.add("disabled");
			guidelinesButton.classList.add("wpbf-button-secondary");
			guidelinesButton.classList.remove("wpbf-button-primary");
		}
	});

	$("#guidelines-agreement").on("click", function () {
		$(".guidelines-button")
			.removeClass("disabled")
			.removeClass("wpbf-button-secondary")
			.addClass("wpbf-button-primary");
	});

	$(".guidelines-button").on("click", function (event) {
		event.preventDefault();
		var button = this;
		button.classList.add("is-loading");

		$.ajax({
			type: "POST",
			url: pm.ajaxurl,
			data: {
				action: "pm_accept_guidelines",
				nonce: pm.nonces.acceptGuidelines,
			},
		})
			.done(function (r) {
				closePopup("guidelines");
				$(".open-guidelines-popup").removeClass("open-guidelines-popup");
			})
			.fail(function () {
				alert("Something went wrong. Please try again.");
			})
			.always(function () {
				button.classList.remove("is-loading");
			});
	});
}
